import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLensF11 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 49",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M48 5.5H0v2h48zm0 36H0v2h48zM33.96 31v-2.247h4.032V18.337h-.189l-3.192 3.78-1.722-1.449 3.633-4.326h4.18v12.411h3.36V31zM21.37 28.753V31h10.1v-2.247h-3.36V16.342H23.93l-3.633 4.326 1.723 1.449 3.192-3.78h.189v10.416zm-10.973 5.418 6.026-18.711h2.247l-6.026 18.711zM3.842 22.159h1.617V31h2.688v-8.841h2.247v-2.121H8.147v-2.436h2.247V15.46H8.483q-1.491 0-2.268.777-.756.777-.756 2.226v1.575H3.842z"
	})
});
export default SvgLensF11;
